"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var HorizontalRule = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "HorizontalRule",
  componentId: "sc-145puba-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    line-height: 1.25em;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    min-height: 1.25em;\n    color: ", "\n\n    :before,\n    :after {\n        border-top: ", " ", " ", ";\n        flex: 1;\n        display: inline-block;\n        content: '';\n        height: 0px;\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), function (props) {
  return props.color || _Colors.dustyGray;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.borderStyle;
}, function (props) {
  return props.borderColor || props.color || _Colors.alto;
}, function (props) {
  return props.size === 'small' && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n            font-size: 13px;\n            margin-top: calc((40px - 1.25em) / 2);\n            margin-bottom: calc((40px - 1.25em) / 2);\n        "])));
}, function (props) {
  return (props.size === 'medium' || !props.size) && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n            margin-top: calc((50px - 1.25em) / 2);\n            margin-bottom: calc((50px - 1.25em) / 2);\n        "])));
}, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n            margin-top: calc((60px - 1.25em) / 2);\n            margin-bottom: calc((60px - 1.25em) / 2);\n        "])));
}, function (props) {
  return props.children ? (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n                  :before {\n                      margin-right: 0.5em;\n                  }\n\n                  :after {\n                      margin-left: 0.5em;\n                  }\n              "]))) : (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n                  :after {\n                      display: none;\n                  }\n              "])));
});

HorizontalRule.propTypes = {
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  color: _propTypes.default.string,
  borderWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  borderStyle: _propTypes.default.oneOf(['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset', 'initial', 'inherit'])
};
HorizontalRule.defaultProps = {
  size: 'medium',
  color: null,
  borderWidth: '1px',
  borderStyle: 'solid'
};
var _default = HorizontalRule;
exports.default = _default;